import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.usrPrflHead'),
      "subtitle": _vm.$i18n_t('Common.usrPrflInfo')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "justify": "center"
    }
  }, [_vm.isImpersonating ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    class: `card-info-box-bg px-2 bg-info-card-danger`,
    staticStyle: {
      "height": "60px"
    }
  }, [_c('div', {
    staticClass: "card-info-box-title"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.impersonating')))]), _c('div', {
    staticClass: "card-info-box-subtitle text-truncate"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.user.impersonatingText')) + "\n        ")])])]) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "7"
    }
  }, [_c('core-two-factor-auth-modal', {
    attrs: {
      "isOpen": _vm.mfaDialogEnableOpen,
      "cancelBtnIcon": "fa-times"
    },
    on: {
      "canceled": _vm.handleMfaEnableCanceled,
      "completed": _vm.handleMfaEnableCompleted
    }
  }), _c('core-two-factor-auth-modal-disable', {
    attrs: {
      "isOpen": _vm.mfaDialogDisableOpen
    },
    on: {
      "canceled": _vm.handleMfaDisableCanceled,
      "completed": _vm.handleMfaDisableCompleted
    }
  }), _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.user.editProfile'),
      "buttons": _vm.buttons01
    },
    on: {
      "saveUserProfile": _vm.saveUserProfile
    }
  }, [_c(VForm, {
    ref: "userForm",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.buttons01[0].valid,
      callback: function ($$v) {
        _vm.$set(_vm.buttons01[0], "valid", $$v);
      },
      expression: "buttons01[0].valid"
    }
  }, [_c(VContainer, [_c('p', {
    staticClass: "pt-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('accMgmt.user.editProfileText')) + "\n            ")]), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.userID'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: _vm.userObject.id,
      callback: function ($$v) {
        _vm.$set(_vm.userObject, "id", $$v);
      },
      expression: "userObject.id"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "rules": _vm.emailRules,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.email'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.userObject.email,
      callback: function ($$v) {
        _vm.$set(_vm.userObject, "email", $$v);
      },
      expression: "userObject.email"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "rules": _vm.reqRules,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.firstName'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.userObject.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.userObject, "firstName", $$v);
      },
      expression: "userObject.firstName"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "rules": _vm.reqRules,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.lastName'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.userObject.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.userObject, "lastName", $$v);
      },
      expression: "userObject.lastName"
    }
  })], 1), _c(VExpansionPanels, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showAddressData,
      expression: "showAddressData"
    }],
    staticClass: "mb-4",
    attrs: {
      "popout": ""
    },
    model: {
      value: _vm.contactPanel,
      callback: function ($$v) {
        _vm.contactPanel = $$v;
      },
      expression: "contactPanel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('Common.contactInfo')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-4"
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "5",
      "xl": "5"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.mobile'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.contactInfo.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.contactInfo, "mobile", $$v);
      },
      expression: "userObject.properties.contactInfo.mobile"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "5",
      "xl": "5"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.phone'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.contactInfo.phone,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.contactInfo, "phone", $$v);
      },
      expression: "userObject.properties.contactInfo.phone"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VExpansionPanels, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showAddressData,
      expression: "showAddressData"
    }],
    staticClass: "mb-4",
    attrs: {
      "popout": ""
    },
    model: {
      value: _vm.addressPanel,
      callback: function ($$v) {
        _vm.addressPanel = $$v;
      },
      expression: "addressPanel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('Common.address')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-4"
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "text",
      "label": _vm.$i18n_t('Common.street'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.address.street,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.address, "street", $$v);
      },
      expression: "userObject.properties.address.street"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "type": "text",
      "label": _vm.$i18n_t('Common.houseNumber'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.address.houseNumber,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.address, "houseNumber", $$v);
      },
      expression: "userObject.properties.address.houseNumber"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "type": "text",
      "label": _vm.$i18n_t('Common.postalCode'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.address.postalCode,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.address, "postalCode", $$v);
      },
      expression: "userObject.properties.address.postalCode"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "type": "text",
      "label": _vm.$i18n_t('Common.city'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.address.city,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.address, "city", $$v);
      },
      expression: "userObject.properties.address.city"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.region')
    },
    model: {
      value: _vm.userObject.properties.address.region,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.address, "region", $$v);
      },
      expression: "userObject.properties.address.region"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "type": "text",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.country'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.userObject.properties.address.country,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.address, "country", $$v);
      },
      expression: "userObject.properties.address.country"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.user.userDefaults'),
      "buttons": _vm.buttons01
    },
    on: {
      "saveUserProfile": _vm.saveUserProfile
    }
  }, [_c(VForm, {
    ref: "userForm",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.buttons01[0].valid,
      callback: function ($$v) {
        _vm.$set(_vm.buttons01[0], "valid", $$v);
      },
      expression: "buttons01[0].valid"
    }
  }, [_c(VContainer, {
    staticClass: "pa-6",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.colorScheme')) + "\n                ")]), _c(VRow, {
    attrs: {
      "justify": "center"
    }
  }, [_vm._l(_vm.colors, function (c) {
    return _c(VAvatar, {
      key: `color-${c}`,
      staticClass: "mx-1",
      attrs: {
        "size": 23
      },
      on: {
        "click": function ($event) {
          _vm.userObject.properties.userDefaults.color = c;
        }
      }
    }, [_c('div', {
      class: ['filterColorPreview-wrapper', `filterColorPreview-${c}`, _vm.userObject.properties.userDefaults.color === c ? 'active' : '']
    })]);
  }), _vm.hasCustomColor ? _c(VAvatar, {
    class: `${_vm.color.startsWith('customerColor') ? 'color-active' : ''} filterColorPreview-customerColor${_vm.UiTheme ? 'Dark' : 'Light'}`,
    attrs: {
      "size": "23"
    },
    on: {
      "click": function ($event) {
        return _vm.setColor('customerColor');
      }
    }
  }) : _vm._e()], 2), _c(VDivider, {
    staticClass: "mt-4"
  })], 1), _c(VCol, {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.language')) + "\n                ")]), _c(VRow, {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(['de', 'gb'], function (code) {
    return _c('div', {
      key: `lang-${code}`,
      staticClass: "mx-1"
    }, [_c(VAvatar, {
      attrs: {
        "size": 25
      },
      on: {
        "click": function ($event) {
          _vm.userObject.properties.userDefaults.language = code === 'gb' ? 'en' : code;
        }
      }
    }, [_c('div', {
      class: ['flag-icon-custom', `flag-icon-${code}`, 'flag-wrapper-custom', _vm.userObject.properties.userDefaults.language === (code === 'gb' ? 'en' : code) ? 'active' : '']
    })])], 1);
  }), 0)], 1), _c(VCol, {
    attrs: {
      "cols": "8"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.mapLayout')) + "\n                ")]), _c(VSelect, {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.mapStyles,
      "hide-details": "",
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "label": _vm.$i18n_t('Common.select'),
      "solo": ""
    },
    model: {
      value: _vm.userObject.properties.userDefaults.mapLayout,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.userDefaults, "mapLayout", $$v);
      },
      expression: "userObject.properties.userDefaults.mapLayout"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDivider, {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.uiSettings')) + "\n                ")]), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_mode",
      "label": _vm.userObject.properties.userDefaults.uiTheme ? _vm.$i18n_t('Common.uiDark') : _vm.$i18n_t('Common.uiLight'),
      "color": _vm.color
    },
    model: {
      value: _vm.userObject.properties.userDefaults.uiTheme,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.userDefaults, "uiTheme", $$v);
      },
      expression: "userObject.properties.userDefaults.uiTheme"
    }
  }), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_drawer",
      "label": _vm.userObject.properties.userDefaults.drawer ? _vm.$i18n_t('Common.uiMenuOn') : _vm.$i18n_t('Common.uiMenuOff'),
      "color": _vm.color
    },
    model: {
      value: _vm.userObject.properties.userDefaults.drawer,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.userDefaults, "drawer", $$v);
      },
      expression: "userObject.properties.userDefaults.drawer"
    }
  }), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_mini_variant",
      "label": _vm.$i18n_t('Common.toggleMiniVariant'),
      "color": _vm.color
    },
    model: {
      value: _vm.userObject.properties.userDefaults.miniVariant,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.userDefaults, "miniVariant", $$v);
      },
      expression: "userObject.properties.userDefaults.miniVariant"
    }
  }), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_map3d",
      "label": _vm.$i18n_t('Common.ui3DMap'),
      "color": _vm.color
    },
    model: {
      value: _vm.userObject.properties.userDefaults.map3DBuild,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.userDefaults, "map3DBuild", $$v);
      },
      expression: "userObject.properties.userDefaults.map3DBuild"
    }
  }), _c(VDivider, {
    staticClass: "mt-2"
  }), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Common.pagination')) + "\n                  ")]), _c(VSelect, {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": [10, 20, 50],
      "label": _vm.$i18n_t('Common.pagination'),
      "hide-details": "",
      "dense": "",
      "solo": ""
    },
    model: {
      value: _vm.userObject.properties.userDefaults.pagination,
      callback: function ($$v) {
        _vm.$set(_vm.userObject.properties.userDefaults, "pagination", $$v);
      },
      expression: "userObject.properties.userDefaults.pagination"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "5"
    }
  }, [_c(VForm, {
    ref: "passwordForm",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handlePwdUpdate.apply(null, arguments);
      }
    },
    model: {
      value: _vm.buttons02[0].valid,
      callback: function ($$v) {
        _vm.$set(_vm.buttons02[0], "valid", $$v);
      },
      expression: "buttons02[0].valid"
    }
  }, [_c('core-n20Card', {
    staticStyle: {
      "min-width": "320px"
    },
    attrs: {
      "buttons": _vm.buttons02
    },
    on: {
      "handlePwdUpdate": _vm.handlePwdUpdate
    }
  }, [_c(VCardText, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.changePassword')))]), _c(VCol, {
    staticClass: "px-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-password-field', {
    attrs: {
      "rules": _vm.reqRules,
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.oldPassword'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "name": "oldPassword",
      "autocomplete": "off",
      "required": ""
    },
    on: {
      "blur": function ($event) {
        if (!_vm.password1 && !_vm.pwOld) {
          _vm.resetValidate();
        }
      }
    },
    model: {
      value: _vm.pwOld,
      callback: function ($$v) {
        _vm.pwOld = $$v;
      },
      expression: "pwOld"
    }
  })], 1), _c(VCol, {
    staticClass: "px-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-password-field', {
    attrs: {
      "rules": [_vm.passwordRules.passNew],
      "error-messages": _vm.passwordError,
      "error": _vm.passwordHasError,
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.newPwd'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "name": "NewPassword1",
      "autocomplete": "off",
      "required": ""
    },
    on: {
      "input": function ($event) {
        return _vm.validatePassword();
      },
      "blur": function ($event) {
        if (!_vm.password1 && !_vm.pwOld) {
          _vm.resetValidate();
        }
      }
    },
    model: {
      value: _vm.password1,
      callback: function ($$v) {
        _vm.password1 = $$v;
      },
      expression: "password1"
    }
  })], 1), _c(VCol, {
    staticClass: "px-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-password-field', {
    attrs: {
      "rules": [_vm.passwordRules.passRepeat],
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.repeatPwd'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "name": "NewPassword2",
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.password2,
      callback: function ($$v) {
        _vm.password2 = $$v;
      },
      expression: "password2"
    }
  })], 1), _c('div', {
    staticClass: "card-description"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('accMgmt.user.accUserPasswordPolicy.header')) + "\n              "), _c('ul', [_c('li', [_vm._v("\n                  " + _vm._s(_vm.$i18n_tc('accMgmt.user.passwordErrors.USER_PASSWORD_MINLENGTH', _vm.passwordPolicy.length, {
    n: _vm.passwordPolicy.length
  })) + "\n                ")]), _vm._l(Object.keys(_vm.passwordPolicy).filter(k => k !== 'length' && _vm.passwordPolicy[k]), function (key) {
    return _c('li', {
      key: `pwdpolicy_${key}`
    }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t(`accMgmt.user.passwordErrors.USER_PASSWORD_${key.toUpperCase()}`)) + "\n                ")]);
  })], 2)])], 1)], 1)], 1), _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('Common.multiFactorAuth.settingsTitle')
    }
  }, [_c(VCardText, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.settingsInfo')) + "\n          ")]), _c(VCol, {
    staticClass: "pl-0 pr-0 d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c(VSwitch, {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": _vm.isProfile2FADisabledByAccount,
      "label": _vm.mfaSwitchValue ? _vm.$i18n_t('Common.multiFactorAuth.settingsSwitchLabel_on') : _vm.$i18n_t('Common.multiFactorAuth.settingsSwitchLabel_off'),
      "data-cy": "profile_toggle_2fa"
    },
    on: {
      "change": _vm.mfaSwitchChange
    },
    model: {
      value: _vm.mfaSwitchValue,
      callback: function ($$v) {
        _vm.mfaSwitchValue = $$v;
      },
      expression: "mfaSwitchValue"
    }
  })], 1), _vm.isProfile2FADisabledByAccount ? _c('p', {
    staticClass: "card-description mt-2",
    attrs: {
      "data-cy": "profile_mandatory_2fa_lock_msg"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('accMgmt.tenant.security.twoFactorAuthenticationRequiredProfileLockInfo')) + "\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };